import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { 
  Cog, 
  Factory, 
  Wrench, 
  Package,
  ArrowRight 
} from 'lucide-react';
import { Button } from '../ui/button';

const capabilities = [
  {
    icon: Cog,
    title: 'Precision Machining',
    description: 'Proses machining presisi untuk pembuatan dan perbaikan komponen industri.',
    link: '/kapabilitas'
  },
  {
    icon: Factory,
    title: 'Metal Fabrication',
    description: 'Pembuatan komponen metal fabricated untuk kebutuhan industri.',
    link: '/kapabilitas'
  },
  {
    icon: Wrench,
    title: 'Repair & Maintenance',
    description: 'Perbaikan dan perawatan equipment industri seperti pump, gearbox, dan lainnya.',
    link: '/kapabilitas'
  },
  {
    icon: Package,
    title: 'Industrial Supply',
    description: 'Penyediaan komponen mechanical dan electrical untuk industri.',
    link: '/kapabilitas'
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};

export const CapabilitiesSection = () => {
  return (
    <section 
      id="capabilities"
      className="py-24 md:py-32 bg-[#f5f7fb]"
      data-testid="capabilities-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <div className="inline-flex items-center gap-2 bg-[#001582]/10 rounded-full px-4 py-2 mb-6">
            <span className="w-2 h-2 bg-[#FFC107] rounded-full" />
            <span className="text-[#001582] text-sm font-semibold uppercase tracking-wider">Kapabilitas</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#1a1a1a] mb-6">
            Kapabilitas <span className="text-[#001582]">Utama</span>
          </h2>
          <p className="text-slate-600 text-lg leading-relaxed">
            Kami menyediakan solusi engineering komprehensif untuk mendukung kebutuhan 
            industri Anda dengan standar kualitas tinggi.
          </p>
        </motion.div>

        {/* Capabilities Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {capabilities.map((capability, index) => (
            <motion.div
              key={capability.title}
              variants={itemVariants}
              className="group"
            >
              <Link to={capability.link}>
                <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-8 h-full hover:shadow-xl hover:-translate-y-2 hover:border-[#001582]/20 transition-all duration-300">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-gradient-to-r from-[#001582] to-[#001ea7] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <capability.icon className="w-8 h-8 text-[#FFC107]" />
                  </div>
                  
                  {/* Content */}
                  <h3 className="font-heading text-xl font-bold text-[#1a1a1a] mb-3 group-hover:text-[#001582] transition-colors">
                    {capability.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    {capability.description}
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-center mt-12"
        >
          <Link to="/kapabilitas">
            <Button 
              size="lg"
              className="bg-gradient-to-r from-[#001582] to-[#001ea7] text-white hover:from-[#001ea7] hover:to-[#001582] font-semibold px-8 py-6 rounded-xl"
              data-testid="capabilities-cta"
            >
              Lihat Semua Kapabilitas
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default CapabilitiesSection;
